// extracted by mini-css-extract-plugin
export default {"warmupCountdown":"warmupCountdown_warmupCountdown__Qmc-7","name":"warmupCountdown_name__B83-u","skip":"warmupCountdown_skip__MEswN"};